import {useLocation} from "react-router";
import {useMemo} from "react";
import {flatRoutes} from "../components/Routes";

export function useMenuName() {
    const location = useLocation();
    
    return useMemo(() => {
        const currentPathname = location.pathname;
        const foundRoute = flatRoutes.find(route => route.pathname === currentPathname);
        
        return foundRoute?.menuName ?? currentPathname;
    }, [location.pathname]);
}